var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.button)?_c('button',{staticClass:"btn-transparent",on:{"click":_vm.click}},[_c('i',{class:{
      [_vm.iconClass]:true,
      [_vm.s.icon]:true,
      [_vm.s.tooltip]:_vm.tooltipe,
      [_vm.s.disabled]:_vm.disabled,
      [_vm.s.isAction]:_vm.isAction,
      [_vm.s.small]:_vm.small,
      [_vm.s.medium]:_vm.medium,
    },style:(_vm.iconStyle)})]):_c('i',{class:{
    [_vm.iconClass]:true,
    [_vm.s.icon]:true,
    [_vm.s.tooltip]:_vm.tooltipe,
    [_vm.s.disabled]:_vm.disabled,
    [_vm.s.isAction]:_vm.isAction,
    [_vm.s.small]:_vm.small,
    [_vm.s.medium]:_vm.medium,
  },style:(_vm.iconStyle),on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }